import { render, staticRenderFns } from "./TvApp.vue?vue&type=template&id=c2c25ab4"
import script from "./TvApp.vue?vue&type=script&lang=js"
export * from "./TvApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports